import * as actions from '../actions/articlesList';
import * as actions2 from '../actions/solicitorArticlesList';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import flattenConcurrently from 'xstream/extra/flattenConcurrently';
import flattenSequentially from 'xstream/extra/flattenSequentially';

export function getArticles(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_ARTICLES)
		.map(action => ({
			url: BASE_URL + 'api/Articles/News?limit=' + action.payload.limit +
			'&offset=' + action.payload.offset +
			'&published=' + action.payload.published +
			'&unpublished=' + action.payload.unpublished + (action.payload.search !==null? '&search=' + action.payload.search:'')
			,
			category: 'getArticles',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('getArticles')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetArticles(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};

}

export function failedGetArticle(sources) {
	let httpResponse$ = sources.HTTP
		.select('getArticles')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200 )
		.map(response => actions.receivefailedResponseGetArticles(response));

	return {
		ACTION: httpResponse$
	}
}

export function getArticlesSolicitorHomePage(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_ARTICLES_SOLICITOR_HOME_PAGE)
		.map(action => ({
			url: BASE_URL + 'api/Articles/News?limit=' + action.payload.limit +
			'&offset=' + action.payload.offset +
			'&published=' + action.payload.published +
			'&unpublished=' + action.payload.unpublished,
			category: 'getArticlesSolicitorHomePage',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('getArticlesSolicitorHomePage')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetArticlesSolicitorHomePage(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};

}

export function failedGetArticlesSolicitorHomePage(sources) {
	let httpResponse$ = sources.HTTP
		.select('getArticlesSolicitorHomePage')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200 )
		.map(response => actions.receiveFailureArticlesSolicitorHomePage(response));

	return {
		ACTION: httpResponse$
	}
}

export function patchArticle(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_PATCH_ARTICLE)
		.map(action => ({
			url: BASE_URL + 'api/Articles/News/' + action.payload.id,
			category: 'patchArticle',
			method: 'PATCH',
			send: action.payload,
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('patchArticle')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.compose(flattenConcurrently)
		.filter(response => response.status === 200)
		.map(response => actions.receivePatchArticle(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};

}

export function failedPatchArticle(sources) {
	let httpResponse$ = sources.HTTP
		.select('patchArticle')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status >= 400 )
		.map(response => actions.receiveFailedResponsePatchArticle(JSON.parse(response.response.text).message));

	return {
		ACTION: httpResponse$
	}
}

export function deleteArticle(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_DELETE_ARTICLE)
		.map(action => ({
			url: BASE_URL + 'api/Articles/News/' + action.payload,
			category: 'deleteArticle',
			method: 'DELETE',
			type: 'application/json',
			withCredentials: true
		}));

	const request2$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_DELETE_ARTICLE)
		.map(action => ({
			payload: action.payload
		}));

	let httpResponse$ = sources.HTTP
		.select('deleteArticle')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.compose(flattenSequentially)
		.filter(response => response.status === 200);

	let httpResponseAction$ = xs.combine(request$, httpResponse$, request2$)
		.map(response => actions.receiveDeleteArticle( response[1].body , response[2].payload));

	return {
		ACTION: httpResponseAction$,
		HTTP: request$
	};

}

export function failedDeleteArticle(sources) {
	let httpResponse$ = sources.HTTP
		.select('deleteArticle')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status >= 400 )
		.map(response => actions.receiveFailedResponseDeleteArticle(JSON.parse(response.response.text).message));

	return {
		ACTION: httpResponse$
	}
}

export function getSpecificArticle(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_SELECTED_ARTICLE)
		.map(action => ({
			url: BASE_URL + 'api/Articles/News/' + action.payload,
			category: 'getSpecificArticle',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('getSpecificArticle')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveSpecificArticle(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};

}

export function failedGetSpecificArticle(sources) {
	let httpResponse$ = sources.HTTP
		.select('getSpecificArticle')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status >= 400 )
		.map(response => actions.receiveFailedResponseGetSpecificArticle(JSON.parse(response.response.text).message));

	return {
		ACTION: httpResponse$
	}
}

export function getArticleMessage(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_ARTICLES_MESSAGE)
		.map(action => ({
			url: BASE_URL + 'api/Articles/Message',
			category: 'getArticlesMessage',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('getArticlesMessage')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveArticlesMessage(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};

}

export function failedGetArticlesMessage(sources) {
	let httpResponse$ = sources.HTTP
		.select('getArticlesMessage')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status >= 400 )
		.map(response => actions.receiveBadRequestArticlesMessage(JSON.parse(response.response.text).message));

	return {
		ACTION: httpResponse$
	}
}


export function getArticleAttachment(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_ARTICLE_ATTACHMENT)
		.map(action => ({
			url: BASE_URL + 'api/Articles/' + action.payload.articleId + '/Attachment/'+ action.payload.attachmentId,
			category: 'getArticleAttachment',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getArticleAttachment')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetArticleAttachment(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveFailedResponseGetArticleAttachment(sources) {
	let httpResponse$ = sources.HTTP
		.select('getArticleAttachment')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receivefailedGetArticleAttachment(response));

	return {
		ACTION: httpResponse$
	};
}



export function getArticlesSuggestions(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_ALL_ARTICLES_SUGGESTIONS)
		.map(action => ({
			url: BASE_URL + 'api/Articles/News?limit=' + action.payload.limit +
			'&offset=' + action.payload.offset +
			'&published=' + action.payload.published +
			'&unpublished=' + action.payload.unpublished + (action.payload.search !==null? '&search=' + action.payload.search:'')
			,
			category: 'getArticlesSuggestions',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('getArticlesSuggestions')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
        .compose(flattenSequentially)
		.filter(response => response.status === 200)
		.map(response => actions2.receiveGetAllArticlesSuggestions(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};

}

export function failedGetArticlesSuggestions(sources) {
	let httpResponse$ = sources.HTTP
		.select('getArticlesSuggestions')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200 )
		.map(response => actions2.receiveBadResponseGetAllArticlesSuggestions(response));

	return {
		ACTION: httpResponse$
	}
}
